import { module } from 'modujs';
import modularLoad from 'modularload';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.load = new modularLoad({
            enterDelay: 500,
            transitions: {
                blog: {
                    loadingClass: 'is-loading-transition-blog',
                    enterDelay: 500
                }
            }
        })

        this.load.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app')
            this.call('update', newContainer, 'app')

            if(transition !== 'blog') {
                this.call('scrollTo', { target: 0, immediate: true }, 'Scroll')
            } else {
                this.call('addScrollElements', newContainer, 'Scroll')
            }

            this.call('bindScrollTo', null, 'Scroll')
        })

        this.load.on('loading', (transition, oldContainer) => {
            this.call('close', null, 'Header')
            this.call('unbindScrollTo', null, 'Scroll')

            if(transition === 'blog') {
                this.call('removeScrollElements', oldContainer, 'Scroll')
                this.call('scrollTo', { target: '#content', offset: -150 }, 'Scroll')
            }

        })
    }

    goTo(obj) {
        this.load?.goTo(obj.url, obj.transition)
    }
}
